<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm nhật ký sao lưu dữ liệu</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <sync-data-source :cached="true" v-model="searchForm.syncSourceType" allowClear="true"></sync-data-source>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6" v-if="searchForm.syncSourceType">
                                <b-form-group label="Đơn vị thực hiện:"
                                              label-for="input-unit"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <unit-tree :cached="true" v-model="searchForm.unitId" ref="unitTree" allowTraversal :traversalOption.sync="searchForm.unitTraversalOption"></unit-tree>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Thao tác:"
                                              label-for="input-action"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 class="form-control"
                                             v-model="searchForm.action" :options="listActions"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                               
                                <b-form-group label="Từ ngày:"
                                              label-for="input-startdate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-startdate" v-model="searchForm.startDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                            <b-col sm="6">
                                <b-form-group label="Đối tượng:"
                                              label-for="input-action"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 class="form-control"
                                             v-model="searchForm.backupType" :options="listBackupTypes"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                                <b-form-group label="Đến ngày:"
                                              label-for="input-enddate"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <date-picker id="input-enddate" v-model="searchForm.endDate" placeholder="dd/mm/yyyy"></date-picker>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col sm="6">
                                <b-form-group label="Trạng thái:"
                                              label-for="input-action"
                                              :label-cols-md="4"
                                              :horizontal="true"
                                              label-align="left">
                                    <select2 class="form-control"
                                             v-model="searchForm.status" :options="listStatuses"
                                             allowClear="true"
                                             placeholder="--- Tất cả ---"></select2>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row class="text-center">
                            <b-col sm="12">
                                <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="logging/backup-logs"
                            gridName="Danh sách nhật ký sao lưu dữ liệu"
                            ref="backupLogTable">
                        <template v-slot:cell(status)="row">
                            <span :class="row.item.status? 'text-success' : 'text-danger'">
                                {{ $store.getters.getStatusName(row.item.status ? 1 : 0) }}
                            </span>
                        </template>
                        <template v-slot:cell(action)="row">
                            {{ row.item.action == 1 ? 'Sao lưu' : 'Phục hồi' }}
                        </template>
                        <template v-slot:cell(backupType)="row">
                            {{ row.item.backupType == 1 ? 'Dữ liệu đơn vị' : 'Dữ liệu toàn hệ thống' }}
                        </template>
                        <template v-slot:cell(backupDate)="row">
                            {{ row.item.backupDate | formatTime }}
                        </template>
                        <template v-slot:cell(backupSize)="row">
                            {{ convertToMB(row.item.backupSize) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button size="sm" :to="{ path: `./${row.item.id}`}" title="xem" variant="info">
                                Xem
                            </b-button>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mapState } from 'vuex'
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListAssetSource',
        mixins: [mixins],
        data() {
            return {
                unitId: null,
                searchForm: {
                    unitId: this.getUnitTreeIdCache(1),
                    unitTraversalOption: this.getUnitTreeTraversalOptionCache(),
                    syncSourceType: this.getSyncSourceTypeCache(),
                    action: null,
                    backupType: null,
                    status: null,
                    startDate: null,
                    endDate: new Date().formatDate()
                },
                gridOptions: {
                    fields: [
                        { key: 'userName', label: 'Tên tài khoản', sortable: true },
                        { key: 'unitName', label: 'Đơn vị', sortable: true, tdAttr: (key, value, item) => ({ title: item.unitFullName }) },
                        { key: 'action', label: 'Thao tác', sortable: true },
                        { key: 'backupType', label: 'Đối tượng', sortable: true },
                        { key: 'backupDate', label: 'Thời gian', sortable: true },
                        { key: 'backupSize', label: 'Dung lượng', sortable: true },
                        { key: 'status', label: 'Trạng thái', sortable: true },
                        { key: 'errorMessage', label: 'Thông tin lỗi', sortable: true }
                    ],
                    sortBy: 'backupDate',
                    sortDesc: true
                },
                listActions: [
                    { id: 1, text: 'Sao lưu' },
                    { id: 2, text: 'Phục hồi' }
                ],
                listBackupTypes: [
                    { id: 1, text: 'Dữ liệu đơn vị' },
                    { id: 2, text: 'Dữ liệu toàn hệ thống' },
                ]
            }
        },
        computed: {
            ...mapState({
                listStatuses: (state) => state.common.listStatuses
            }),
        },
        created() {
        },
        methods: {
            search() {
                this.$refs.backupLogTable.refresh();
            },
            loadUserNameByUnitId() {
                var vm = this;
                console.log(vm.unitId);
                return this.$services.get(`users/get-list-users/${this.unitId}`).done(response => {
                    vm.listActors = response;
                });
            },
            convertToMB(byte) {
                if (byte) {
                    return (Math.ceil((byte / 1024 / 1024) * 100) / 100).toFixed(2) + ' MB';
                } else {
                    return '';
                }
            }
        }
    }
</script>
<style scoped>
</style>
